import { useEditActivities } from './hooks/useEditActivitites';

export const EditActivities = () => {
	const { getComponent } = useEditActivities();

	return getComponent();
};
